import axios from 'axios';
import { authHelper } from '@/utils/auth';

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL, // Usa la variable de entorno
  timeout: 10000, // Opcional: tiempo máximo de espera
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// Interceptor para añadir el token a las peticiones
api.interceptors.request.use(config => {
  const token = authHelper.getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  if (config.data instanceof FormData) {
    config.headers['Content-Type'] = 'multipart/form-data';
  }

  return config;
}, error => {
  return Promise.reject(error);
});

// Interceptor para manejar respuestas de error
api.interceptors.response.use(response => response, error => {
  if (error.response && error.response.status === 401) {
    // Token inválido o expirado
    authHelper.logout();
  }
  return Promise.reject(error);
});

export default api; 